import { BreedFilter } from "./breeds.types";

export const breedsFilter: BreedFilter[] = [
  {
    attribute: "Tamanho",
    values: [
      { label: "Mini", value: "Mini" },
      { label: "Pequeno", value: "Pequeno" },
      { label: "Médio", value: "Medio" },
      { label: "Grande", value: "Grande" },
      { label: "Gigante", value: "Gigante" }
    ]
  },
  {
    attribute: "Pelo",
    values: [
      { label: "Sem pelo", value: "Sem pelo", specie: "gato" },
      { label: "Pelo curto", value: "Pelo curto" },
      { label: "Pelo médio", value: "Pelo médio" },
      { label: "Pelo longo", value: "Pelo longo" }
    ]
  },
  {
    attribute: "Energia",
    specie: "cachorro",
    values: [
      { label: "Energia baixa", value: "Energia baixa" },
      { label: "Energia média", value: "Energia média" },
      { label: "Energia alta", value: "Energia alta" }
    ]
  },
  {
    attribute: "Classificação FCI",
    specie: "cachorro",
    infoText: "Escolha o grupo",
    helperText:
      "Esta é uma lista apenas de raças de cães reconhecidas pela Federação Cinológica Internacional (FCI).",
    values: [
      {
        label: "Grupo 1 - Pastor e Boieiros (excepto Boiadeiros Suíços)",
        value: "Grupo 1 - Pastor e Boieiros (excepto Boiadeiros Suíços)"
      },
      {
        label:
          "Grupo 2 - Pinscher e Schnauzer, Molossóides e Cães de Montanha, e Boieiros Suiços",
        value:
          "Grupo 2 - Pinscher e Schnauzer, Molossóides e Cães de Montanha, e Boieiros Suiços"
      },
      {
        label: "Grupo 3 - Terriers",
        value: "Grupo 3 - Terriers"
      },
      {
        label: "Grupo 4 - Dachshunds",
        value: "Grupo 4 - Dachshunds"
      },
      {
        label: "Grupo 5 - Cães de tipo Spitz e de tipo Primitivo",
        value: "Grupo 5 - Cães de tipo Spitz e de tipo Primitivo"
      },
      {
        label: "Grupo 6 - Sabujos Farejadores e Raças Assemelhadas",
        value: "Grupo 6 - Sabujos Farejadores e Raças Assemelhadas"
      },
      {
        label: "Grupo 7 - Cães de Parar ou Cães Apontadores",
        value: "Grupo 7 - Cães de Parar ou Cães Apontadores"
      },
      {
        label:
          "Grupo 8 - Cães Levantadores e Cobradores de Caça e Cães de Água",
        value: "Grupo 8 - Cães Levantadores e Cobradores de Caça e Cães de Água"
      },
      {
        label: "Grupo 9 - Cães de Companhia",
        value: "Grupo 9 - Cães de Companhia"
      },
      {
        label: "Grupo 10 - Galgos (Lébreis)",
        value: "Grupo 10 - Galgos (Lébreis)"
      },
      {
        label: "Grupo 11 - Raças não reconhecidas pela FCI",
        value: "Grupo 11 - Raças não reconhecidas pela FCI"
      }
    ]
  },
  {
    attribute: "Classificação FIFe",
    specie: "gato",
    infoText: "Escolha o grupo",
    helperText:
      "Esta é uma lista apenas de raças de gatos reconhecidas pela Federação Internacional Felina (FIFe).",
    values: [
      { label: "Categoria I", value: "Categoria I" },
      { label: "Categoria II", value: "Categoria II" },
      { label: "Categoria III", value: "Categoria III" },
      { label: "Categoria IV", value: "Categoria IV" }
    ]
  }
] as const;

export const chipsValues = [
  { label: "Mini", value: "Mini" },
  { label: "Pequeno", value: "Pequeno" },
  { label: "Médio", value: "Medio" },
  { label: "Grande", value: "Grande" },
  { label: "Gigante", value: "Gigante" }
] as const;
